export default __webpack_public_path__ + "static/media/resumo-highlight.66fd84b7.svg";